const BASE_URL = 'https://dev.exdev.ir/v1/'
const SOCKET_URL = 'https://dev.exdev.ir/'
const HOME = "https://digiminex.ir/"


export {
    BASE_URL,
    SOCKET_URL,
    HOME
}
